import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconSkipBackwardFifteen = () => (
    <Wrapper>
        <IconForwardRotate icon={icon({ name: 'rotate-right', style: 'solid' })} />
        <IconForwardOne icon={icon({ name: '1', style: 'solid' })} />
        <IconForwardFive icon={icon({ name: '5', style: 'solid' })} />
    </Wrapper>
);

const Wrapper = styled.div`
    position: relative;
    color: var(--neutral500);
    margin-top: 0.25rem;
`;

const IconForwardRotate = styled(FontAwesomeIcon)`
    font-size: 1rem;
`;

const IconForwardOne = styled(FontAwesomeIcon)`
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 5px;
    height: 0.5rem;
    background: var(--neutral50);
`;

const IconForwardFive = styled(FontAwesomeIcon)`
    position: absolute;
    bottom: 5px;
    right: 0;
    width: 5px;
    height: 0.5rem;
    background: var(--neutral50);
`;

export default IconSkipBackwardFifteen;
